import { createFileRoute } from "@tanstack/react-router";
import { CategoryHubPageEn, hubJsonLdEn } from "@/components/CategoryHubPageEn";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

export const Route = createFileRoute("/en/legal/")({
  loader: async () => {
    const { PILLARS_EN } = await import("@/data/category-pillars-extra");
    return { pillar: PILLARS_EN["legal"] };
  },
  head: ({ loaderData }) => {
    const pillar = loaderData?.pillar;
    if (!pillar) return { meta: [{ title: "NYC Language Institute" }, { name: "robots", content: "noindex" }] };
    const url = `${SEO_SITE}/en/legal`;
    return {
      meta: [
        { title: ctaTitle(pillar.metaTitle, "/en/legal", "en")},
        { name: "description", content: ctaDesc(pillar.metaDesc, "/en/legal", "en")},
        { property: "og:title", content: ctaTitle(pillar.metaTitle, "/en/legal", "en")},
        { property: "og:description", content: ctaDesc(pillar.metaDesc, "/en/legal", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/legal")],
      scripts: hubJsonLdEn(pillar, url),
    };
  },
  component: PillarRoute,
});

function PillarRoute() {
  const { pillar } = Route.useLoaderData();
  return <CategoryHubPageEn pillar={pillar} />;
}
